module.exports = __webpack_public_path__ + "img/clinicLogo.d3ee7e3d.jpg";